// This data is keyed by brand ID and contains the required fields for JSON-LD product schema
// a future improvement will be to dynamically populate this from the backend

export interface BrandSchemaData {
    brandId: number;
    brandName: string;
    wikidataUrl: string;
    wikipediaUrl: string;
    officialUrl: string;
}

export const brandSchemaData: Record<number, BrandSchemaData> = {
    300: {
        brandId: 300,
        brandName: 'Home Depot',
        wikidataUrl: 'https://www.wikidata.org/wiki/Q864407',
        wikipediaUrl: 'https://en.wikipedia.org/wiki/The_Home_Depot',
        officialUrl: 'https://www.homedepot.com',
    },
    887: {
        brandId: 887,
        brandName: "Dick's Sporting Goods",
        wikidataUrl: 'https://www.wikidata.org/wiki/Q5272601',
        wikipediaUrl: 'https://en.wikipedia.org/wiki/Dick%27s_Sporting_Goods',
        officialUrl: 'https://www.dickssportinggoods.com',
    },
    707: {
        brandId: 707,
        brandName: 'Walmart',
        wikidataUrl: 'https://www.wikidata.org/wiki/Q483551',
        wikipediaUrl: 'https://en.wikipedia.org/wiki/Walmart',
        officialUrl: 'https://www.walmart.com',
    },
    684: {
        brandId: 684,
        brandName: 'Target',
        wikidataUrl: 'https://www.wikidata.org/wiki/Q1046951',
        wikipediaUrl: 'https://en.wikipedia.org/wiki/Target_Corporation',
        officialUrl: 'https://www.target.com',
    },
    137: {
        brandId: 137,
        brandName: 'Chipotle Mexican Grill',
        wikidataUrl: 'https://www.wikidata.org/wiki/Q465751',
        wikipediaUrl: 'https://en.wikipedia.org/wiki/Chipotle_Mexican_Grill',
        officialUrl: 'https://www.chipotle.com',
    },
    326: {
        brandId: 326,
        brandName: 'Krispy Kreme',
        wikidataUrl: 'https://www.wikidata.org/wiki/Q1192805',
        wikipediaUrl: 'https://en.wikipedia.org/wiki/Krispy_Kreme',
        officialUrl: 'https://www.krispykreme.com',
    },
    771: {
        brandId: 771,
        brandName: 'Panda Express',
        wikidataUrl: 'https://www.wikidata.org/wiki/Q1358690',
        wikipediaUrl: 'https://en.wikipedia.org/wiki/Panda_Express',
        officialUrl: 'https://www.pandaexpress.com',
    },
    650: {
        brandId: 650,
        brandName: 'Starbucks',
        wikidataUrl: 'https://www.wikidata.org/wiki/Q37158',
        wikipediaUrl: 'https://en.wikipedia.org/wiki/Starbucks',
        officialUrl: 'https://www.starbucks.com',
    },
    510: {
        brandId: 510,
        brandName: 'Panera Bread',
        wikidataUrl: 'https://www.wikidata.org/wiki/Q7130852',
        wikipediaUrl: 'https://en.wikipedia.org/wiki/Panera_Bread',
        officialUrl: 'https://www.panerabread.com',
    },
    613: {
        brandId: 613,
        brandName: "See's Candies",
        wikidataUrl: 'https://www.wikidata.org/wiki/Q2103510',
        wikipediaUrl: 'https://en.wikipedia.org/wiki/See%27s_Candies',
        officialUrl: 'https://www.sees.com',
    },
    440: {
        brandId: 440,
        brandName: "Little Caesar's Pizza",
        wikidataUrl: 'https://www.wikidata.org/wiki/Q1393809',
        wikipediaUrl: 'https://en.wikipedia.org/wiki/Little_Caesars',
        officialUrl: 'https://www.littlecaesars.com',
    },
    703: {
        brandId: 703,
        brandName: 'Visa',
        wikidataUrl: 'https://www.wikidata.org/wiki/Q328840',
        wikipediaUrl: 'https://en.wikipedia.org/wiki/Visa_Inc.',
        officialUrl: 'https://www.visa.com',
    },
    222: {
        brandId: 222,
        brandName: "Dunkin' Donuts",
        wikidataUrl: 'https://www.wikidata.org/wiki/Q847743',
        wikipediaUrl: 'https://en.wikipedia.org/wiki/Dunkin%27_Donuts',
        officialUrl: 'https://www.dunkindonuts.com',
    },
    50: {
        brandId: 50,
        brandName: 'AMC Theatres',
        wikidataUrl: 'https://www.wikidata.org/wiki/Q294721',
        wikipediaUrl: 'https://en.wikipedia.org/wiki/AMC_Theatres',
        officialUrl: 'https://www.amctheatres.com',
    },
    48: {
        brandId: 48,
        brandName: 'Amazon',
        wikidataUrl: 'https://www.wikidata.org/wiki/Q3884',
        wikipediaUrl: 'https://en.wikipedia.org/wiki/Amazon_(company)',
        officialUrl: 'https://www.amazon.com',
    },
    71: {
        brandId: 71,
        brandName: 'Bath & Body Works',
        wikidataUrl: 'https://www.wikidata.org/wiki/Q810773',
        wikipediaUrl: 'https://en.wikipedia.org/wiki/Bath_%26_Body_Works',
        officialUrl: 'https://www.bathandbodyworks.com',
    },
    146: {
        brandId: 146,
        brandName: 'Cinemark Theatres',
        wikidataUrl: 'https://www.wikidata.org/wiki/Q707530',
        wikipediaUrl: 'https://en.wikipedia.org/wiki/Cinemark_Theatres',
        officialUrl: 'https://www.cinemark.com',
    },
    704: {
        brandId: 704,
        brandName: 'ShopRite',
        wikidataUrl: 'https://www.wikidata.org/wiki/Q7501097',
        wikipediaUrl: 'https://en.wikipedia.org/wiki/ShopRite',
        officialUrl: 'https://www.shoprite.com',
    },
    285: {
        brandId: 285,
        brandName: 'H-E-B',
        wikidataUrl: 'https://www.wikidata.org/wiki/Q830621',
        wikipediaUrl: 'https://en.wikipedia.org/wiki/H-E-B',
        officialUrl: 'https://www.heb.com',
    },
    617: {
        brandId: 617,
        brandName: 'Sheetz',
        wikidataUrl: 'https://www.wikidata.org/wiki/Q7492551',
        wikipediaUrl: 'https://en.wikipedia.org/wiki/Sheetz',
        officialUrl: 'https://www.sheetz.com',
    },
    706: {
        brandId: 706,
        brandName: "Sam's Club",
        wikidataUrl: 'https://www.wikidata.org/wiki/Q1972120',
        officialUrl: 'https://www.samsclub.com',
    },
    528: {
        brandId: 528,
        brandName: 'Pizza Hut',
        wikidataUrl: 'https://www.wikidata.org/wiki/Q191615',
        officialUrl: 'https://www.pizzahut.com',
    },
    680: {
        brandId: 680,
        brandName: 'Southwest Airlines',
        wikidataUrl: 'https://www.wikidata.org/wiki/Q503308',
        officialUrl: 'https://www.southwest.com',
    },
    687: {
        brandId: 687,
        brandName: 'Texas Roadhouse',
        wikidataUrl: 'https://www.wikidata.org/wiki/Q7707945',
        officialUrl: 'https://www.texasroadhousemenues.com',
    },
    648: {
        brandId: 648,
        brandName: 'Sprouts Farmers Market',
        wikidataUrl: 'https://www.wikidata.org/wiki/Q7581369',
        officialUrl: 'https://www.sprouts.com',
    },
    614: {
        brandId: 614,
        brandName: 'Sephora',
        wikidataUrl: 'https://www.wikidata.org/wiki/Q2408041',
        officialUrl: 'https://www.sephora.com',
    },
    756: {
        brandId: 756,
        brandName: 'Whole Foods Market',
        wikidataUrl: 'https://www.wikidata.org/wiki/Q1809448',
        officialUrl: 'https://www.wholefoodsmarket.com',
    },
    266: {
        brandId: 266,
        brandName: 'Giant Eagle',
        wikidataUrl: 'https://www.wikidata.org/wiki/Q1522721',
        officialUrl: 'https://www.gianteagle.com',
    },
    709: {
        brandId: 709,
        brandName: 'Weis Markets',
        wikidataUrl: 'https://www.wikidata.org/wiki/Q7980370',
        officialUrl: 'https://www.weismarkets.com',
    },
    786: {
        brandId: 786,
        brandName: 'Biggby',
        wikidataUrl: 'https://www.wikidata.org/wiki/Q4906876',
        officialUrl: 'https://www.biggby.com',
    },
    120: {
        brandId: 120,
        brandName: 'The Cheesecake Factory',
        wikidataUrl: 'https://www.wikidata.org/wiki/Q1045842',
        officialUrl: 'https://www.thecheesecakefactory.com',
    },
    788: {
        brandId: 788,
        brandName: 'Live Event Card',
        wikidataUrl: '',
        officialUrl: '',
    },
    963: {
        brandId: 963,
        brandName: 'Wounded Warrior Project',
        wikidataUrl: 'https://www.wikidata.org/wiki/Q8037407',
        officialUrl: 'http://www.woundedwarriorproject.org',
    },
    247: {
        brandId: 247,
        brandName: "Cheryl's Cookies",
        wikidataUrl: '',
        officialUrl: '',
    },
    862: {
        brandId: 862,
        brandName: 'Cracker Barrel',
        wikidataUrl: 'https://www.wikidata.org/wiki/Q4492609',
        officialUrl: 'https://www.crackerbarrel.com',
    },
    683: {
        brandId: 683,
        brandName: 'Tanger Outlets',
        wikidataUrl: 'https://www.wikidata.org/wiki/Q7682888',
        officialUrl: 'https://www.tanger.com',
    },
    111: {
        brandId: 111,
        brandName: 'Caribou Coffee',
        wikidataUrl: 'https://www.wikidata.org/wiki/Q5039494',
        officialUrl: 'https://www.cariboucoffee.com',
    },
    504: {
        brandId: 504,
        brandName: 'Omaha Steaks',
        wikidataUrl: 'https://www.wikidata.org/wiki/Q7089458',
        officialUrl: 'https://www.omahasteaks.com',
    },
    647: {
        brandId: 647,
        brandName: 'Superior Grocers',
        wikidataUrl: 'https://www.wikidata.org/wiki/Q124810975',
        officialUrl: 'https://superiorgrocers.com',
    },
    832: {
        brandId: 832,
        brandName: 'Roblox',
        wikidataUrl: 'https://www.wikidata.org/wiki/Q692989',
        officialUrl: 'https://www.roblox.com',
    },
    // Mock data for development/testing - not part of production requirements
    // 328: {
    //     brandId: 328,
    //     brandName: 'Kohl\'s',
    //     wikidataUrl: 'https://www.wikidata.org/wiki/Q967342',
    //     wikipediaUrl: 'https://en.wikipedia.org/wiki/Kohl%27s',
    //     officialUrl: 'https://www.kohls.com',
    // }
};
